import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { PawPrint, Home, ArrowLeft, Search } from "lucide-react"
import { useTranslation } from "react-i18next"
import "../assets/styles/NotFound.css"

const NotFound = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [pawPrints, setPawPrints] = useState([])

  // Handle mouse movement to create paw prints
  const handleMouseMove = (e) => {
    // Only add a paw print occasionally to avoid too many
    if (Math.random() > 0.97) {
      const newPawPrint = {
        id: Date.now(),
        x: e.clientX,
        y: e.clientY,
        rotation: Math.random() * 360,
        size: 16 + Math.random() * 10,
      }

      setPawPrints((prev) => {
        // Keep only the last 15 paw prints
        const updated = [...prev, newPawPrint]
        if (updated.length > 15) {
          return updated.slice(updated.length - 15)
        }
        return updated
      })
    }
  }

  // Remove paw prints after some time
  useEffect(() => {
    if (pawPrints.length > 0) {
      const timeout = setTimeout(() => {
        setPawPrints((prev) => prev.slice(1))
      }, 2500)
      return () => clearTimeout(timeout)
    }
  }, [pawPrints])

  // Navigate back to home
  const goHome = () => {
    navigate("/")
  }

  // Navigate back
  const goBack = () => {
    navigate(-1)
  }

  return (
    <div className="not-found-container" onMouseMove={handleMouseMove}>
      {/* Paw prints that follow the cursor */}
      {pawPrints.map((paw) => (
        <div
          key={paw.id}
          className="paw-print"
          style={{
            left: paw.x,
            top: paw.y,
            transform: `rotate(${paw.rotation}deg)`,
            fontSize: `${paw.size}px`,
          }}
        >
          <PawPrint />
        </div>
      ))}

      <div className="not-found-content">
        <div className="not-found-header">
          <div className="not-found-number">4</div>
          <div className="not-found-zero">
            <Search className="search-icon" size={40} />
          </div>
          <div className="not-found-number">4</div>
        </div>

        <h1 className="not-found-title">{t("notFound.title")}</h1>
        <p className="not-found-message">{t("notFound.message")}</p>

        <div className="action-button3s">
          <button className="action-button3 home-button" onClick={goHome}>
            <Home size={18} />
            <span>{t("notFound.goHome")}</span>
          </button>
          <button className="action-button3 back-button" onClick={goBack}>
            <ArrowLeft size={18} />
            <span>{t("notFound.goBack")}</span>
          </button>
        </div>
      </div>

      {/* Decorative paws in background */}
      <div className="decorative-paws">
        {[...Array(12)].map((_, i) => (
          <PawPrint
            key={i}
            size={10 + Math.random() * 20}
            className="decorative-paw"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              opacity: 0.1 + Math.random() * 0.2,
              transform: `rotate(${Math.random() * 360}deg)`,
            }}
          />
        ))}
      </div>
    </div>
  )
}

export default NotFound
